/** Aligns with API workspace_event.type (customer-facing labels only). */
export const WORKSPACE_EVENT_TYPES = {
  MESSAGE: 'message',
  UPLOAD: 'upload',
  REVISION_REQUEST: 'revision_request',
  DOCUMENT_REQUEST: 'document_request',
  APPROVAL: 'approval',
  CONFIRMATION_REQUEST: 'confirmation_request',
  SYSTEM: 'system',
  STATUS_CHANGE: 'status_change',
};

/** Types that carry optional note / document / due in `metadata` (not as Comment rows). */
export const WORKSPACE_EVENT_STRUCTURED_REQUEST_TYPES = [
  WORKSPACE_EVENT_TYPES.REVISION_REQUEST,
  WORKSPACE_EVENT_TYPES.DOCUMENT_REQUEST,
  WORKSPACE_EVENT_TYPES.APPROVAL,
  WORKSPACE_EVENT_TYPES.CONFIRMATION_REQUEST,
];

/** Request `status` values that close the thread for new replies (aligns with API). */
export const WORKSPACE_EVENT_STATUS_TERMINAL = ['approved', 'rejected', 'resolved'];

export function workspaceEventReplyBlocked(eventType, status) {
  if (eventType === WORKSPACE_EVENT_TYPES.STATUS_CHANGE || eventType === WORKSPACE_EVENT_TYPES.SYSTEM) {
    return true;
  }
  if (!WORKSPACE_EVENT_STRUCTURED_REQUEST_TYPES.includes(eventType)) {
    return false;
  }
  const st = status != null && String(status).trim() !== '' ? String(status).trim().toLowerCase() : '';
  return WORKSPACE_EVENT_STATUS_TERMINAL.includes(st);
}

export const WORKSPACE_EVENT_PORTAL_ACTIONS = {
  REQUEST_REVISION: 'request_revision',
  REQUEST_DOCUMENT: 'request_document',
  REQUEST_CONFIRMATION: 'request_confirmation',
};

export const WORKSPACE_EVENT_TYPE_LABELS = {
  [WORKSPACE_EVENT_TYPES.MESSAGE]: 'Message',
  [WORKSPACE_EVENT_TYPES.UPLOAD]: 'File upload',
  [WORKSPACE_EVENT_TYPES.REVISION_REQUEST]: 'Revision request',
  [WORKSPACE_EVENT_TYPES.DOCUMENT_REQUEST]: 'Document request',
  [WORKSPACE_EVENT_TYPES.APPROVAL]: 'Approval',
  [WORKSPACE_EVENT_TYPES.CONFIRMATION_REQUEST]: 'Confirmation',
  [WORKSPACE_EVENT_TYPES.SYSTEM]: 'Notice',
  [WORKSPACE_EVENT_TYPES.STATUS_CHANGE]: 'Status update',
};

export const WORKSPACE_EVENT_STATUS_LABELS = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Declined',
  resolved: 'Resolved',
};

export function workspaceEventTypeLabel(type) {
  return WORKSPACE_EVENT_TYPE_LABELS[type] || 'Update';
}

export function workspaceEventStatusLabel(status) {
  if (!status) return null;
  return WORKSPACE_EVENT_STATUS_LABELS[status] || status;
}

export function humanizeFieldKey(field) {
  if (!field) return '';
  if (field === 'status_workflow') return 'Progress';
  if (field === 'status_payment') return 'Payment';
  if (field === 'status') return 'Status';
  return field.replace(/_/g, ' ');
}

export function humanizeValue(value) {
  if (value === null || value === undefined || value === '') return '—';
  return String(value).replace(/_/g, ' ');
}
